import {
  useEntryLockController,
  type EntryLockOptions,
} from "src/generator/hooks/useEntryLockController";

const V2_OPTIONS: EntryLockOptions = {
  keepLockDuringSaveModal: true,
  releaseOnSaveModalCancel: true,
};

/**
 * V2 Entry Lock Management.
 */
export const useV2EntryLock = () => useEntryLockController(V2_OPTIONS);
